<template>
    <div>
        <WebDataRocks
            v-if="ready"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks'

export default {
    name: 'BudgetRollingPivot',

    components: {
        WebDataRocks,
    },

    data() {
        return {
            pivotConfig: {
                dataSource: {},
                slice: {},
                options: {
                    grid: {
                        type: 'classic',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'off',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: '',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 0,
                        maxSymbols: 20,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    computed: {
        year() {
            return new Date().getFullYear()
        },
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            try {
                const response = await axios.get(
                    `/dashboard/rolling-budget/pivot/${this.year}`
                )
                this.pivotData = response.data.data
                this.setInitialReport()
            } catch (error) {
                console.log(error)
            }
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                reportFilters: [{ uniqueName: 'Cabinet' }],
                rows: [
                    { uniqueName: 'Type', sort: 'asc' },
                    { uniqueName: 'Measures' },
                ],
                columns: [{ uniqueName: 'Date.Month' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
